import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { AllowList } from 'sections/onsite-campaigns/types';

export const useSetAllowList = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (ips: AllowList[]) =>
      dispatch({
        type: 'SET_CAMPAIGN_ALLOWLIST',
        payload: { allowList: [...ips] },
      }),
    [dispatch],
  );
};
